import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../auth/useAuth';
import { makeApi } from '../api/client';

export default function PendingRoute() {
  const { getAccessToken, logout } = useAuth();
  const api = makeApi(getAccessToken);
  const { data } = useQuery({
    queryKey: ['org', 'me'],
    queryFn: async () => {
      const result = await api.org.me();
      return result.data;
    },
    refetchInterval: 30_000,
  });
  const status = data?.org.status;
  const activated = status === 'active';
  return (
    <div className="mx-auto max-w-lg p-8 text-center">
      <img src="/brand/logo.png" alt="Dhuttu" className="mx-auto w-40 mb-6" />
      <h1 className="text-2xl font-bold text-primary">{data?.org.name ?? 'Your merchant'}</h1>
      {activated ? (
        <>
          <p className="mt-4 text-emerald-700 font-medium">
            Your merchant has been activated.
          </p>
          <p className="mt-1 text-ink/70 text-sm">
            Sign in again to refresh your session and access the dashboard.
          </p>
          <button
            type="button"
            onClick={() => logout()}
            className="mt-6 inline-block rounded-md bg-primary px-6 py-2 text-white font-medium hover:opacity-90"
          >
            Login
          </button>
        </>
      ) : (
        <>
          <p className="mt-4 text-ink/80">
            Awaiting Dhuttu approval. We will email you when your merchant is activated.
          </p>
          <p className="mt-1 text-ink/60 text-sm">
            Current status: <span className="font-medium">{status ?? 'loading…'}</span>
          </p>
          <a href="mailto:hello@dhuttu.app" className="mt-6 inline-block text-accent underline">
            Email Dhuttu support
          </a>
        </>
      )}
    </div>
  );
}
